import { Injectable } from '@angular/core';
import { RunTimeConfigService } from '@shared/services/run-time-config.service';

@Injectable({
  providedIn: 'root'
})
export class HelperUtilityService {
  private readonly appConfig: any;
  constructor(private runTimeConfigService: RunTimeConfigService) {
    this.appConfig = this.runTimeConfigService.getConfig('appConfig');
  }

  // Transform JSON array of objects or an object as per schema
  transformResponse(schema: any, input: any, skipFirst?: boolean) {
    const isSchemaArray = Array.isArray(schema);
    const isInputObjArray = Array.isArray(input);

    if (isSchemaArray && isInputObjArray) {
      let outputObject;
      const schemaObj = schema[0];
      outputObject = [];

      for (const [i, ele] of input.entries()) {
        if (skipFirst && i === 0) {
          outputObject.push(ele);
        } else {
          outputObject.push(this.renameKeys(schemaObj, ele));
        }
      }

      return outputObject;
    } else {
      return this.renameKeys(schema, input);
    }
  }

  parseJWT(token: string) {
    if (!token) {
      return {};
    }
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (e) {
      return;
    }
  }

  deepSameKeys(o1: any, o2: any) {
    const o1keys = Object.keys(o1).sort();
    const o2keys = Object.keys(o2).sort();
    console.log('o1keys', o1keys);
    console.log('o2keys', o2keys);
    if (o1keys.join() !== o2keys.join()) {
      console.log(o1keys.join());
      console.log(o2keys.join());
      return false;
    }
    return o1keys.every(key => {
      const v1 = o1[key];
      const v2 = o2[key];
      if (v1 === null) {
        return v2 === null;
      }
      const t1 = typeof v1;
      const t2 = typeof v2;

      if (t1 !== t2) {
        console.log(t1);
        console.log(t2);
        return false;
      }
      return t1 === 'object' ? this.deepSameKeys(v1, v2) : true;
    });
  }

  mergeJsons(jsoneOne: any, jsonTwo: any) {
    const resultData: any = {};
    Object.keys(jsonTwo).forEach(firstKey => {
      resultData[firstKey] = jsonTwo[firstKey];
    });
    Object.keys(jsoneOne).forEach(SecKey => {
      Object.keys(resultData).forEach(resultKey => {
        if (resultKey === SecKey && typeof resultData[resultKey] === 'object') {
          Object.keys(jsoneOne[resultKey]).forEach(subChild => {
            let isChildFound = false;
            Object.keys(jsonTwo[resultKey]).forEach(secJsonItem => {
              if (secJsonItem === subChild) {
                isChildFound = true;
                resultData[resultKey][subChild] = jsoneOne[resultKey][subChild];
              }
            });
          });
        }
      });
    });
    return resultData;
  }

  stringToObj(path: string, obj: any) {
    const parts = path.split('.');

    const last = parts.pop();
    let part;
    while (true) {
      part = parts.shift();
      if (!part) {
        break;
      }
      if (typeof obj[part] !== 'object') {
        obj[part] = {};
      }

      obj = obj[part];
    }

    return obj.find(item => item.feature === last);
  }

  formatBytes(bytes: number, decimals: number = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  private renameKeys(schemaObj: any, inputObj: any) {
    const tmp = {};
    return Object.keys(inputObj).reduce((acc, key) => {
      const updatedKey = Object.keys(schemaObj).find(k => schemaObj[k] === key);
      if (updatedKey) {
        tmp[updatedKey] = inputObj[key];
      } else {
        // if a property has been replaced, do not add it again
        if (!Object.keys(tmp).includes(key)) {
          tmp[key] = inputObj[key];
        }
      }
      return tmp;
    }, {});
  }
}
